import { Box, Typography, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomTooltipBox from "../../../../../Components/CustomTooltips/CustomTooltipBox";

const ModalHeader = ({ title, onClose, steps, activeStep }) => {
  const { t } = useTranslation([
    "pricelist-modal",
    "categories",
    "tooltip-sections",
  ]);

  const tooltipMessages = [
    t("pricelist_modal_price_services", {
      ns: "tooltip-sections",
      returnObjects: true,
    }),
    t("pricelist_modal_location_settings", {
      ns: "tooltip-sections",
      returnObjects: true,
    }),
    t("pricelist_modal_additional_info", {
      ns: "tooltip-sections",
      returnObjects: true,
    }),
  ];

  return (
    <Box
      sx={{
        background: "#fff",
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: 2,
          borderBottom: "1px solid #EAEAEA",
          background: "#fff",
          boxShadow: "0px 3px 8px 0px rgba(47, 43, 61, 0.08)",
        }}
      >
        <Typography sx={{ fontWeight: 500, fontSize: "19px" }}>
          {t(title, { ns: "categories" })}
        </Typography>

        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            justifyContent: "center",
          }}
        >
          {steps}
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CustomTooltipBox sections={tooltipMessages[activeStep]} />
          </Box>
          <IconButton onClick={onClose}>
            <img src="/cancel_icon.svg" alt="close" />
          </IconButton>
        </Box>
      </Box>
      <Box
        sx={{
          flex: 2,
          p: 2,
          display: { xs: "flex", md: "none" },
          justifyContent: "center",
        }}
      >
        {steps}
      </Box>
    </Box>
  );
};

export default ModalHeader;
